import { TDealType } from '@cian/api-models/offer-card/v1/get-offer-data';

export function getTitle(dealType: TDealType, isCommercial: boolean) {
  if (isCommercial) {
    return 'История изменения цены за м²/год';
  }

  return dealType === 'sale' ? 'История цены' : 'История арендной ставки';
}
